import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const GalleryButtons = () => {
  const location = useLocation(); // Hook to get the current location
  const [activePage, setActivePage] = useState(location.pathname);

  useEffect(() => {
    setActivePage(location.pathname); // Update the active page when the location changes
  }, [location]);

  return (
    <>
      <div className="gallery-btns-container">
        <Link
          className={`gallery-btn ${activePage === "/gallery/afrostalgia" ? "active" : ""
            }`}
          to="/gallery/afrostalgia"
        >
          {/* <h3>Afrostalgia</h3> */}
          <button>Afrostalgia Gallery</button>
        </Link>
        <Link
          className={`gallery-btn ${activePage === "/gallery/afrostalgia2" ? "active" : ""
            }`}
          to="/gallery/afrostalgia2"
        >
          {/* <h3>Afrosounds</h3> */}
          <button>Afrostalgia 2 Gallery</button>
        </Link>
        <Link
          className={`gallery-btn ${activePage === "/gallery/afrosounds" ? "active" : ""
            }`}
          to="/gallery/afrosounds"
        >
          {/* <h3>Afrosounds2</h3> */}
          <button>Afrosounds Gallery</button>
        </Link>
        <Link
          className={`gallery-btn ${activePage === "/gallery/tacexperience" ? "active" : ""
            }`}
          to="/gallery/tacexperience"
        >
          {/* <h3>TAC Experience</h3> */}
          <button>TAC Experience Gallery</button>
        </Link>{" "}
        <Link
          className={`gallery-btn ${activePage === "/gallery/introsummer" ? "active" : ""
            }`}
          to="/gallery/introsummer"
        >
          {/* <h3>TAC Experience</h3> */}
          <button>Introducing Summer</button>
        </Link>{" "}
        <Link
          className={`gallery-btn ${activePage === "/gallery/theoffseason" ? "active" : ""
            }`}
          to="/gallery/theoffseason"
        >
          {/* <h3>TAC Experience</h3> */}
          <button>The Offseason</button>
        </Link>
      </div>
    </>
  );
};

export default GalleryButtons;
